<template>
  <ul class="options-ul suboptions" v-if="option.children">
    <li
      class="option-item"
      v-for="(suboption, index) in option.children"
      :value="index"
      :key="index"
    >
      <a
        class="suboption option-link"
        :style="`padding-left: ${20 * node}px`"
        v-on:click="
          Array.isArray(suboption.children) && suboption.children.length == 0
            ? onClickItem(suboption)
            : () => null
        "
      >
        <span class="icon" v-if="Array.isArray(suboption.children)">
          <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
            <path
              fill="currentColor"
              d="M10,17L15,12L10,7V17Z"
              v-if="!option.open"
            />
            <path
              fill="currentColor"
              d="M7,10L12,15L17,10H7Z"
              v-if="option.open"
            />
          </svg>
        </span>
        <span
          :class="`${
            !Array.isArray(suboption.children) || suboption.children.length == 0
              ? 'ml-3'
              : ''
          }`"
          >{{ suboption.label }}
          <span
            v-if="
              Array.isArray(suboption.children) && suboption.children.length > 0
            "
            class="number-resume"
          >
            ({{ suboption.children.length }})
          </span>
        </span>
      </a>
      <sub-option
        :option="suboption"
        :onClickItem="onClickItem"
        :node="node + 1"
      ></sub-option>
    </li>
  </ul>
</template>
<script>
export default {
  name: "SubOption",
  props: ["option", "node", "onClickItem"],
  methods: {},
};
</script>
